import { getOutputPreset } from '@/content/instagram'
import { CollageFamily, getCollageTemplate } from '@/content/collageTemplates'
import {
  NodeKind,
  TransformKind,
  firstImageNode,
  isIdentityAdjustments,
  mapNodes,
  summarizeOrientation,
  type Document,
} from '@/core/document'
import { FrameStyleId, formatDate } from '@/tools/frame/params'

const COLLAGE_FAMILY_LABELS: Readonly<Record<CollageFamily, string>> = {
  [CollageFamily.Grid]: 'Grid',
  [CollageFamily.Prints]: 'Prints',
}

function hasAdjustments(document: Document): boolean {
  let adjusted = false
  mapNodes(document.root, (node) => {
    const params = node.kind === NodeKind.Image
      ? node.transforms[TransformKind.Adjustments]
      : undefined
    if (params && !isIdentityAdjustments(params)) adjusted = true
    return node
  })
  return adjusted
}

export function summarizeDocument(document: Document): string {
  const adjustmentSuffix = hasAdjustments(document) ? ' · adjusted' : ''
  if (document.root.kind === NodeKind.Collage) {
    const photoCount = document.root.cells.filter((child) => child !== null).length
    const family = getCollageTemplate(document.root.templateId).family
    return `Collage · ${photoCount} ${photoCount === 1 ? 'photo' : 'photos'} · ${COLLAGE_FAMILY_LABELS[family]}${adjustmentSuffix}`
  }
  const fragments = [getOutputPreset(document.output.presetId).ratioLabel]
  if (document.root.kind === NodeKind.Frame) {
    fragments.unshift(document.root.params.styleId === FrameStyleId.Polaroid ? 'Polaroid' : 'Frame')
    if (document.root.params.styleId === FrameStyleId.Polaroid && document.root.params.date) {
      fragments.push(formatDate(document.root.params.date, document.root.params.dateFormatId))
    }
  }
  const orientation = firstImageNode(document.root).transforms[TransformKind.Orientation]
  if (orientation) fragments.push(summarizeOrientation(orientation))
  return `${fragments.filter(Boolean).join(' · ')}${adjustmentSuffix}`
}
